import cookie from 'js-cookie';
const mutations = {
  /**
  * 设置未读消息数量
  * @param  {[type]} state [description]
  * @param  {[type]} data  [description]
  * @return {[type]}       [description]
  */
  noticeUpdate(state, data) {
    state.noticeUpdate = data;
  },

  /**
   * 通用 更改store state的值
   * @param  {[type]} state [description]
   * @param  {[type]} data  [description]
   * @return {[type]}       [description]
   */
  changeState(state, data) {
    // console.log(data);
    state[data.index] = data.val;
  },

  /**
   * 更改店铺管理状态
   * @param  {[type]} state [description]
   * @param  {[type]} data  [description]
   * @return {[type]}       [description]
   */
  changeManageState(state, data) {
    // console.log(data);
    state.manageState = data;
    cookie.set('manageState', state.manageState, {
      expires: 7
    });
  },

  /**
   * 记录token到vuex
   * @param  {[type]} state [description]
   * @param  {[type]} data  [description]
   * @return {[type]}       [description]
   */
  tokenToVuex(state, data) {
    let token = cookie.get('token');
    if (token != undefined) {
      state.token = token;
    }
  },
  /**
   * 同步用户信息到vuex
   * @param  {[type]} state [description]
   * @param  {[type]} data  [description]
   * @return {[type]}       [description]
   */
  userToVuex(state, data) {
    let user = cookie.get('user');
    if (user != undefined) {
      state.user = JSON.parse(user);
    }
  },

  /**
   * 店铺授权后写入 VUEX & Cookie
   * @param {[type]} state [description]
   * @param {[type]} data  [description]
   */
  // addShopToken(state, data) {
  //   let id = parseInt(data.id)
  //   state.shopToken[id] = data.val;
  //   cookie.set('shopToken', state.shopToken)
  // },

  /**
   * 设置平台Code
   * @param {[type]} state [description]
   * @param {[type]} data  [description]
   */
  setPlatform(state, data) {
    state.platform = data;
    cookie.set('platform', state.platform, {
      expires: 7
    });
  },

  /**
   * 设置平台信息
   * @param {[type]} state [description]
   * @param {[type]} data  [description]
   */
  setPlatformInfo(state, data) {
    state.platforminfo = data;
    cookie.set('platforminfo', JSON.stringify(state.platforminfo), {
      expires: 7
    });
  },

  /**
   * 添加店铺信息
   * @param {[type]} state [description]
   * @param {[type]} data  [description]
   */
  addShopInfo(state, data) {
    state.shopInfo = {};
    state.shopInfo[data.store_id] = data;
    cookie.set('shopInfo', state.shopInfo, {
      expires: 7
    });
  },
  /**
   * 设置店铺买家请求头
   * @param {[type]} state [description]
   * @param {[type]} data  [description]
   */
  setShopIntercept(state, data) {
    state.intercept = data;
    cookie.set('intercept', data, {
      expires: 7
    });
  },

  /**
   * 切换店铺
   * @param  {[type]} state [description]
   * @param  {[type]} data  [description]
   * @return {[type]}       [description]
   */
  // switchShop(state, data) {
  //   let id = parseInt(data.id)
  //   state.shopToken[id] = data.val;
  //   cookie.set('shopInfo', state.shopInfo)
  // },

  /**
   * 帐号登录 记录到 VUEX & Cookie
   * @param  {[type]} state [description]
   * @param  {[type]} data  [description]
   * @return {[type]}       [description]
   */
  cookieLoginToVuex(state, data) {
    let token = cookie.get('token');
    if (token != undefined) {
      state.token = token;
    }

    let user = cookie.get('user');
    if (user != undefined) {
      state.user = JSON.parse(user);
    }

    let manageState = cookie.get('manageState');
    // if (manageState != undefined) {
    state.manageState = cookie.get('manageState'); //JSON.parse(manageState);
    // }

    let shopInfo = cookie.get('shopInfo');
    if (shopInfo != undefined && user && manageState) {
      state.shopInfo = JSON.parse(shopInfo);
      // state.manageState = shopInfo.id;
    }

    let platform = cookie.get('platform');
    if (platform != undefined) {
      state.platform = platform;
    }

    let platforminfo = cookie.get('platforminfo');
    if (platforminfo != undefined) {
      state.platforminfo = JSON.parse(platforminfo);
    }

    // 买家端 店铺请求头
    let intercept = cookie.get('intercept');
    if (intercept) {
      state.intercept = intercept;
    }
  },

  /**
   * 退出登录 清空 VUEX & Cookie
   * @param  {[type]} state [description]
   * @return {[type]}       [description]
   */
  logout(state) {
    cookie.remove('token');
    cookie.remove('user');
    cookie.remove('shopInfo');
    cookie.remove('manageState');
    localStorage.removeItem('businessData');
    localStorage.removeItem('power');

    state.token = '';
    state.user = '';
    state.shopInfo = {};
    state.manageState = false;
    state.power = {
      storeId: null, // 店铺id
      userId: null, // 用户id
      router: [], // 可访问的路由
      menuList: [] // 对应可见菜单
    };
  },
  /**
   * 平台信息失效 清除平台信息 重新获取
   * @param state
   */
  clearPlatForm(state) {
    cookie.remove('platform');
    cookie.remove('platforminfo');

    state.platforminfo = '';
    state.platform = '';
  },

  // 更新侧栏菜单数组
  updatePower(state, data) {
    state.power = data;
    let newData = JSON.parse(JSON.stringify(data));
    delete newData.menuList;
    localStorage.clear();
    localStorage.setItem('power', JSON.stringify(newData));
  },

  //更新店铺开通服务状态
  setMemberState(state, data) {
    state.memberState = data;
  },

  // 开通旺铺确认弹框
  setOpenPopupModel(state, data) {
    state.openPopupModel = data;
  }
};
export default mutations;
